<template lang="pug">
    include ../../media/pug/mixins
    +b.SIDEBAR-TAB.preview-viewer(
    name="preview-viewer"
    )
        template(v-slot:header="")
            +e.header-panel
                +e.H2.title.title._size_md {{ $t('SKETCHES') }}
                +e.basket(v-if="choosePages.length")
                    +e.V-ICON.icon-add.icon(name="cart")
                    +e.summa.icon_round  {{ choosePages.length }}
            +e.range(v-if='!isMobile')
                +e.VUE-SLIDER.slider(
                    v-model="zoom"
                    v-bind="rangeOptions"
                )
        template(v-slot:container="")
            +e.UL.list(ref="imgsContainer")
                +e.LI.item(
                    v-for="(item, idx) in content"
                    v-bind:key="'preview' + idx"
                    v-bind:style="imgStyles"
                    v-on:click="changePage(item)"
                )
                    +e.picture(
                        v-lazyload="true"
                        v-bind:class="previewClass(item)"
                    )
                        rsl-loader.preview-viewer__loader(
                            viewType="book"
                            iconClass="preloader-icon__thumb"
                            centered
                        )
                        +e.IMG.img(v-bind:data-url="`api/viewer/pdf?docId=${$route.params.id}&page=${item}&type=preview`")
                    +e.SPAN.count {{ item }}
</template>

<script>
import { mapGetters } from 'vuex';
import RslLoader from '@RSL/RslLoader/RslLoader';
import VueSlider from 'vue-slider-component';
import SidebarTab from '@/components/partials/SidebarTab';
import onePageScroll from '@/helpers/mixins/one-page-scroll';

export default {
    components: {
        RslLoader,
        SidebarTab,
        VueSlider
    },
    mixins: [onePageScroll],
    props: {
        width: {
            type: Number,
            required: true,
            default: 0
        }
    },
    data() {
        return {
            zoom: 1,
            rangeOptions: {
                steps: [],
                min: 1,
                max: 3,
                interval: 0.25,
                process: false,
                dotSize: 12,
                height: 2,
                tooltip: 'none'
            },
            img: {
                BASIC_WIDTH: 100,
                BASIC_HEIGHT: 180
            },
            scrollContainer: null,
            scrollItems: null,
            choosePages: [],
            choosePagesString: '',
            isViewerMode: true,
            observerElement: document.body
        };
    },
    computed: {
        ...mapGetters([
            'isMobile',
            'getIsOnePage',
            'getGeneralInfo',
            'getCartPages'
        ]),
        currentPage() {
            return this.$route.query.page;
        },
        content() {
            return this.getGeneralInfo.maxPages;
        },
        imgStyles() {
            return {
                width: `${this.img.BASIC_WIDTH * this.zoom}px`,
                height: `${this.img.BASIC_HEIGHT * this.zoom}px`
            };
        }
    },
    watch: {
        async zoom() {
            await this.$nextTick();
            this.scrollToPage();
        },
        width() {
            this.scrollToPage();
        },
        $route(to, from) {
            this.scrollToPage(from);
        },
        getCartPages() {
            this.choosePagesString = '';
            this.choosePages = [];
        }
    },
    activated() {
        this.scrollToPage();
    },
    async mounted() {
        this.setSliderParams();
        this.scrollContainer = document.querySelector('.preview-viewer__scroll-container');
        this.scrollItems = document.querySelectorAll('.preview-viewer__item');
        await this.$nextTick();
        this.scrollToPage();
    },
    methods: {
        changePage(page) {
            const { rotate, negative } = this.$route.query;
            this.$router.push({
                query: {
                    page,
                    rotate,
                    negative
                }
            });
            if (this.isMobile) {
                this.$store.commit('SET_MOB_MENU_IS_VISIBLE', false);
            }
            if (this.getIsOnePage) this.$onePageScroll(page);
        },
        btnClass() {
            return {
                btn_theme_fill: this.choosePages.length,
                btn_theme_unactive: !this.choosePages.length
            };
        },
        previewClass(item) {
            return {
                'preview-viewer__picture_is_active': +this.currentPage === item
            };
        },
        scrollToPage(from) {
            const prevPage = from ? this.scrollItems[from.query.page - 1] : null;
            const page = this.scrollItems[this.currentPage - 1];
            this.containerScrollTo({
                page,
                prevPage
            });
        },
        containerScrollTo(params) {
            const { page, prevPage } = params;
            let behavior;
            if (prevPage) {
                behavior = Math.abs(page.offsetTop - prevPage.offsetTop) > 1000
                    ? 'auto'
                    : 'smooth';
            } else {
                behavior = 'auto';
            }
            if (this.scrollContainer && page) {
                this.scrollContainer.scroll({
                    behavior,
                    left: 0,
                    top: page.offsetTop
                });
            }
        },
        setSliderMaxValue() {
            const { max, interval } = this.rangeOptions;
            let countedMax = max;
            const imgPadding = 20;
            (function checkMaxValue() {
                if ((countedMax * this.img.BASIC_WIDTH) + imgPadding > this.$refs.imgsContainer.clientWidth) {
                    countedMax -= interval;
                    checkMaxValue.call(this);
                }
            }.bind(this)());
            return countedMax;
        },
        setSliderSteps() {
            const { max, min, interval } = this.rangeOptions;
            const steps = [];
            let i = 0;
            while (min + (interval * i) <= max) {
                steps.push(min + (interval * i));
                i += 1;
            }
            return steps;
        },
        setSliderParams() {
            this.rangeOptions.max = this.setSliderMaxValue();
            this.rangeOptions.steps = this.setSliderSteps();
        }
    }
};
</script>

<style lang="sass" src="@/media/sass/components/modules/preview-viewer.sass"></style>
